import { __decorate } from "tslib";
import FindCustomer from "@/components/FindCustomer.vue";
import CustomerCard from "@/components/CustomerCard.vue";
import { mapActions, mapGetters, mapState } from 'vuex';
import ButtonLoading from "@/components/ButtonLoading.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
let MergeCustomers = class MergeCustomers extends Vue {
    toCustomerId;
    fromCustomerId = '';
    merge;
    getCustomer;
    isLoading;
    complete() {
        let data = { toCustomerId: this.toCustomerId, fromCustomerId: this.fromCustomerId };
        this.merge(data).then(() => {
            this.$emit('success');
        }).catch(() => {
            this.$toasted.global.error({});
            this.$emit('failed');
        }).finally(() => {
            this.fromCustomerId = '';
            this.$emit('finished');
        });
    }
    get customer() {
        return this.getCustomer(this.fromCustomerId);
    }
    get finderQuery() {
        return { _id: { $ne: this.toCustomerId } };
    }
    get buttonDisabled() {
        return !this.fromCustomerId;
    }
    get tooltip() {
        return this.buttonDisabled ? this.$t('No customer was selected') : '';
    }
};
__decorate([
    Prop({ type: String, required: true })
], MergeCustomers.prototype, "toCustomerId", void 0);
MergeCustomers = __decorate([
    Component({
        components: { ButtonLoading, CustomerCard, FindCustomer },
        methods: {
            ...mapActions('customers-merge', { merge: 'create' }),
        },
        computed: {
            ...mapGetters('customers', { getCustomer: 'get' }),
            ...mapState('customers-merge', { isLoading: 'isCreatePending' }),
        }
    })
], MergeCustomers);
export default MergeCustomers;
